var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-12 my-8"},[_c('GlobalTextEditorDisplay',_vm._b({},'GlobalTextEditorDisplay',{ value: _vm.field.content },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }